export default __webpack_public_path__ + "static/media/xeniaverse.3eb4082f.png";